import React, { useState, useEffect } from "react";
import "./EventTypesDashboard.scss";
import { getEventTypes } from "../../services/otsEventService";
import TitleBarEventType from "./TitleBarEventType";
import EditEventType from "./EditEventType";
import "../../theme/styles.css";
import EventTypeCard from "./EventTypeCard";
import { Switch, Route, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux' 
import { useAuthentication } from "meportal/AuthenticationProvider";
import CreateEventType from "./CreateEventType";
import { EventTypeProvider } from "../../providers/EventTypeProvider";
import { EventType } from "../../Models/EventType";
import { eventTypeList } from "../../store/feature/EventTypesSlice";
import { editEventType } from "../../store/feature/EventTypeSlice";
import OTSModal from "../Modal/OTSModal";

export default function EventTypesDashboard() {
  const dispatch = useDispatch();
  const allEvents = useSelector((state) => state.eventTypes.eventTypeList);
  
  const [refresh, setRefresh] = useState(false);
  const { userData, getLatestAccessToken } = useAuthentication();
  const rootPath = "/event-types";
  const history = useHistory();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [activeEventTypes, setActiveEventTypes] = useState<EventType[]>(
    []
  );
  const [closedEventTypes, setClosedEventTypes] = useState<EventType[]>(
    []
  );
  const [eventType, setEventTypeDetails] = useState<EventType>();
  const [createToggle, setCreateToggle] = useState(false);

  const clickCreate = (click: any) => {
    setCreateToggle(!createToggle);
    history.push(rootPath + "/create-event-type");
  };

  function handleCardClick(eventType: EventType) {
    dispatch(editEventType(eventType));
    setEventTypeDetails(eventType);
    history.push(rootPath + "/edit-event-type");
  }

  //add a function that takes a string and makes first letter uppercase in each word
  function toTitleCase(str: string) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }

  function reloadData() {
    setRefresh(!refresh);
  }
  function activeEventTypesList(data: any) {
    if (data !== undefined && Array.isArray(data)) {
      const activeData = data.filter(item => item.IsActive === true);
      setActiveEventTypes(activeData);
    }
  }
  function inActiveEventTypesList(data: any) {
    if (data !== undefined && Array.isArray(data)) {
      const closedData = data.filter(item => item.IsActive === false);
      setClosedEventTypes(closedData);
    }
  }

  useEffect(() => {
    if (userData.profile.company){
      activeEventTypesList(allEvents);
      inActiveEventTypesList(allEvents);
      setEventTypeDetails(undefined);
      getLatestAccessToken().then((token) => {
        getEventTypes(token, userData.profile.company, userData.profile.email).then(
          (data) => {
            activeEventTypesList(data);
            inActiveEventTypesList(data);
            setIsLoaded(true);
            dispatch(eventTypeList(data));
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
        );
      });
    }
    return () => {
      console.log('active user hook unmounting');
    };
  }, [userData, refresh]);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div className="loading-container">Loading...</div>;
  } else {
    return (
      <React.Fragment>
          <Switch>
           <Route path={rootPath + "/create-event-type"}>
            <OTSModal>
              <TitleBarEventType
                eventTitle = ""
                contextPath={rootPath}
              ></TitleBarEventType> 
              <EventTypeProvider eventTypeName="">
                <CreateEventType 
                refreshDashboard={reloadData}/>
              </EventTypeProvider>   
            </OTSModal>            
            </Route>  
            <Route path={rootPath + "/edit-event-type"}>
            <OTSModal>
            <TitleBarEventType
                contextPath={rootPath}
                eventTitle={"Edit " + (eventType?.Name || "")}
              ></TitleBarEventType> 
              <EditEventType 
                contextPath={rootPath}
                eventType={eventType}
                refreshDashboard={reloadData}>
              </EditEventType>
              </OTSModal>
              </Route>
            <Route path={rootPath}>
             <TitleBarEventType
                key="titleBarEventType"
                contextPath={rootPath}
                createClicked={clickCreate}
              ></TitleBarEventType> 
              <div className="event-management data-container" key="cheeseAndCrackers">
                <div key="activeEventTypes" className="eventTypeDivider eventTypeLabel">Active event type</div>
                <div className="event-type-cards-container">
                {Array.isArray(activeEventTypes) &&
                  activeEventTypes?.map((eType: any) => (
                    <div key={eType.id + eType.Name} className="data-card-event-type">
                      <EventTypeCard
                        eventType={eType}
                        onCardClick={() => handleCardClick(eType)}
                      />
                    </div>
                  ))}
                </div>
                 { closedEventTypes.length > 0 && 
                 <div key="closedEventTypes"  className="closedEventTypeDivider eventTypeLabel">Inactive event type</div>
                 }
                 <div className="event-type-cards-container">
                 { Array.isArray(closedEventTypes) &&
                   closedEventTypes?.map((eType: any) => (
                    <div key={eType.id + eType.Name} className="data-card-event-type">
                      <EventTypeCard
                         eventType={eType}
                         onCardClick={() => handleCardClick(eType)}
                      />
                    </div>
                  ))}
                  </div>
              </div>
             
            </Route>
          </Switch>
      </React.Fragment>
    );
  }
}
